import { CommonModule } from '@angular/common';
import { Component, input, model, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ParentButtonComponent } from '../../../../shared/components/ui/parent-button/parent-button.component';

@Component({
  selector: 'app-identity-consent-card',
  standalone: true,
  imports: [CommonModule, TranslatePipe, ParentButtonComponent],
  templateUrl: './identity-consent-card.component.html',
  styleUrl: './identity-consent-card.component.scss',
})
export class IdentityConsentCardComponent {
  titleKey = input.required<string>();
  bodyKey = input.required<string>();
  leadLabelKey = input.required<string>();
  pointKeys = input.required<string[]>();
  noteKey = input.required<string>();
  checkboxLabelKey = input.required<string>();
  backLabelKey = input<string>('app.identity.verify.back');
  continueLabelKey = input<string>('app.identity.verify.continue');
  panelAriaLabel = input<string>('Consent details');
  leadIconSrc = input<string>('/public/svgs/identity-id.svg');
  checked = model<boolean>(false);
  busy = input<boolean>(false);

  back = output<void>();
  continue = output<void>();
}
